<template>
  <div>
    <a-table :scroll="{ x: 1300 }" :pagination="false" :columns="columns" size="middle" :data-source="dataSource" row-key="id">
      <template slot="customTitle" slot-scope="text, record">
        <a class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
      </template>
      <template slot="target" slot-scope="text, record">
        {{ requirementTargetMap[record.target] ? requirementTargetMap[record.target].label : '--' }}
      </template>
      <template slot="status" slot-scope="text, record">
        <a-tag v-if="requirementStatus[String(record.flowStepId)]" :color="requirementStatus[String(record.flowStepId)].color"> {{ requirementStatus[String(record.flowStepId)].title }}</a-tag>
        <a-tag v-else>{{ status }}</a-tag>
      </template>
      <template slot="productLine" slot-scope="text, record">
        {{ productLineMap[record.productLine] ? productLineMap[record.productLine].label : '--' }}
      </template>
      <template slot="action" slot-scope="text, record">
        <a @click="onRemove(record)">移除</a>
      </template>
    </a-table>
  </div>
</template>

<script>
import { requirementTarget, productLine, requirementStatus } from '@/utils/dictionary';

const columns = [
  {
    width: 80,
    title: 'ID',
    customRender: (_, record) => 'BR-' + record.id
  },
  {
    width: 300,
    ellipsis: true,
    title: '标题',
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    width: 130,
    ellipsis: true,
    title: '状态',
    scopedSlots: { customRender: 'status' }
  },
  {
    width: 120,
    title: '需求目的',
    key: 'target',
    dataIndex: 'target',
    scopedSlots: { customRender: 'target' }
  },
  {
    width: 100,
    title: '主业务方',
    customRender: (_, record) => record.businessPartner.nickname || '--'
  },
  {
    width: 160,
    title: '关联业务方',
    customRender: (_, record) => record.businessCorrelation.map(item => item.nickname).join('; ') || '--'
  },
  // {
  //   width: 200,
  //   title: '涉及产品线',
  //   scopedSlots: { customRender: 'productLine' }
  // },
  {
    width: 100,
    title: '关联人',
    customRender: (_, record) => record.relatedPerson.nickname || '--'
  },
  {
    width: 165,
    title: '关联时间',
    key: 'relatedTime',
    dataIndex: 'relatedTime'
  },
  {
    width: 165,
    title: '创建时间',
    key: 'createdTime',
    dataIndex: 'createdTime'
  },
  {
    width: 165,
    title: '更新时间',
    key: 'updatedTime',
    dataIndex: 'updatedTime'
  }
];

export default {
  props: {
    dataSource: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columns,
      productLine,
      loading: false,
      requirementTarget
    };
  },
  computed: {
    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:business:requirement:detail',
          params: { id: record.id }
        }).href;
      };
    },
    requirementStatus() {
      return this.$store.getters.getGlobalBusinessStatus();
    },
    requirementTargetMap() {
      return this.requirementTarget.reduce((results, item, _) => {
        results[item.value] = item;
        return results;
      }, {});
    },
    productLineMap() {
      return this.productLine.reduce((results, item, _) => {
        results[item.value] = item;
        return results;
      }, {});
    }
  },
  methods: {
    onRemove(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要解除与该业务需求的关联关系吗?',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          console.log(record.id, self.loading);
        }
      });
    }
  }
};
</script>
